import React, { useEffect, useState } from "react";
import { API_BASE } from "../api/config";
import LocationSelect from "../components/LocationSelect";
import "./BossAlertsPanel.css";

const SHOPS = [
  "ALL",
  "GMP",
  "OSHT",
  "OSPF",
  "MT",
  "JS",
  "JCHT",
  "JCPF",
  "MDYHT",
  "MDYPF",
];

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

function formatMoney(value) {
  return Number(value || 0).toLocaleString();
}

function getAlertIcon(type) {
  if (type === "CASH_CLOSING_DIFFERENCE") return "⚠️";
  if (type === "COD_PENDING") return "🚚";
  if (type === "NEGATIVE_NET_CASH") return "📉";
  if (type === "HIGH_EXPENSE") return "💸";
  return "🔔";
}

export default function BossAlertsPanel() {
  const [shop, setShop] = useState("ALL");
  const [date, setDate] = useState(todayKey());
  const [alerts, setAlerts] = useState([]);
  const [summary, setSummary] = useState({
    total: 0,
    high: 0,
    medium: 0,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function loadAlerts() {
    try {
      setLoading(true);
      setError("");

      const res = await fetch(
        `${API_BASE}/api/erp/finance-alerts?shop=${shop}&date=${date}`,
      );

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to load boss alerts");
      }

      setAlerts(data.rows || []);
      setSummary(data.summary || { total: 0, high: 0, medium: 0 });
    } catch (err) {
      setError(err.message || "Boss alerts loading failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadAlerts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shop, date]);

  return (
    <div className="bossAlerts">
      <div className="bossAlerts__head">
        <div>
          <span>Boss Alerts</span>
          <h2>Management Warning Center</h2>
          <p>
            Important finance warnings for cash closing, COD pending, negative
            cash and high expense.
          </p>
        </div>

        <div className="bossAlerts__filters">
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />

          <LocationSelect value={shop} onChange={setShop} mode="shop" includeAll />

          <button onClick={loadAlerts} disabled={loading}>
            {loading ? "Loading..." : "Refresh"}
          </button>
        </div>
      </div>

      {error && <div className="bossAlerts__error">{error}</div>}

      <div className="bossAlerts__summary">
        <div className="bossAlertSummaryCard">
          <span>Total Alerts</span>
          <strong>{formatMoney(summary.total)}</strong>
        </div>

        <div className="bossAlertSummaryCard bossAlertSummaryCard--high">
          <span>High Priority</span>
          <strong>{formatMoney(summary.high)}</strong>
        </div>

        <div className="bossAlertSummaryCard bossAlertSummaryCard--medium">
          <span>Medium Priority</span>
          <strong>{formatMoney(summary.medium)}</strong>
        </div>
      </div>

      <div className="bossAlerts__list">
        {alerts.length === 0 ? (
          <div className="bossAlerts__empty">
            <strong>✅ No warning alerts</strong>
            <p>Everything looks normal for the selected date and shop.</p>
          </div>
        ) : (
          alerts.map((alert, index) => (
            <div
              key={`${alert.type}-${alert.shopCode}-${index}`}
              className={
                alert.severity === "HIGH"
                  ? "bossAlertItem bossAlertItem--high"
                  : "bossAlertItem bossAlertItem--medium"
              }
            >
              <div className="bossAlertItem__icon">
                {getAlertIcon(alert.type)}
              </div>

              <div className="bossAlertItem__body">
                <div className="bossAlertItem__top">
                  <strong>{alert.title}</strong>
                  <span>{alert.severity}</span>
                </div>

                <p>{alert.message}</p>

                <small>
                  Shop: {alert.shopCode || "-"} | Amount:{" "}
                  {formatMoney(alert.amount)} Ks
                </small>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}


